module.exports = __webpack_public_path__ + "images/welcome-ss3.jpg";